import React, { useState } from 'react'
import { Link } from "react-router-dom"
import axios from 'axios'
import { toast } from 'react-toastify'
import { PulseLoader } from 'react-spinners'

const API_URL = process.env.REACT_APP_API_URL

const Forget = () => {
    const [email, setEmail] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [successMessage, setSuccessMessage] = useState('')

    const handleSubmit = async (e) => {
        e.preventDefault()
        
        // Clear any previous messages
        setErrorMessage('')
        setSuccessMessage('')

        // Validation
        if (!email.trim()) {
            setErrorMessage('Please enter your email address')
            return
        }

        // Basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!emailRegex.test(email)) {
            setErrorMessage('Please enter a valid email address')
            return
        }

        setIsLoading(true)

        try {
            const payload = {
                action: 'forgot-password',
                email: email.trim()
            }

            const response = await axios.post(API_URL, payload)

            // Parse the response - handle both string and object responses
            let responseData = response.data
            if (typeof responseData === 'string') {
                try {
                    responseData = JSON.parse(responseData)
                } catch (parseError) {
                    responseData = response.data
                }
            }

            // Check if API call was successful
            if (responseData.success === true) {
                setSuccessMessage('Password reset link has been sent.')
                // toast.success(responseData.message || 'If an account exists with this email, a password reset link has been sent.', { autoClose: 3000 })
                // Clear email field after successful submission
                setEmail('')
            } else {
                setErrorMessage(responseData.message || 'Failed to send password reset link')
                // toast.error(responseData.message || 'Failed to send password reset link', { autoClose: 2000 })
            }
        } catch (error) {
            console.error('Forgot password error:', error)
            let errorMsg = 'An error occurred while processing your request'
            if (error.response && error.response.data) {
                let errorData = error.response.data
                if (typeof errorData === 'string') {
                    try {
                        errorData = JSON.parse(errorData)
                    } catch (e) {
                        // Use error message as is
                    }
                }
                errorMsg = errorData.message || errorMsg
            }
            setErrorMessage(errorMsg)
            toast.error(errorMsg, { autoClose: 2000 })
        } finally {
            setIsLoading(false)
        }
    }

    // Clear error message when user starts typing
    const handleEmailChange = (e) => {
        setEmail(e.target.value)
        if (errorMessage) {
            setErrorMessage('')
        }
        if (successMessage) {
            setSuccessMessage('')
        }
    }

    return (
        <div className="hold-transition login-page accent-custom">
            <div className="login-box login_div">
                <div className="card card-outline card-primary">
                    <div className="card-header text-center">
                        <div className="login_logo"><img src="/assets/img/color icon_circle.png" border={0} alt="Logo" /></div>
                    </div>
                    <div className="card-body d-flex flex-row flex_flow_rowwrap align_items_cntr">
                        <div className="col-12 col-sm-12 col-md-12">
                            <h5 className="login-box-msg mb-3">Forgot Password</h5>
                            <form onSubmit={handleSubmit}>
                                {errorMessage && (
                                    <div className="alert alert-danger mb-3" role="alert">
                                        {errorMessage}
                                    </div>
                                )}
                                {successMessage && (
                                    <div className="alert alert-success mb-3" role="alert">
                                        {successMessage}
                                    </div>
                                )}
                                <div className="input-group mb-3">
                                    <input
                                        type="email"
                                        className="form-control"
                                        placeholder="Your Registered Email Address"
                                        value={email}
                                        onChange={handleEmailChange}
                                        required
                                        disabled={isLoading}
                                    />
                                    <div className="input-group-append">
                                        <div className="input-group-text">
                                            <i className="fa-solid fa-user" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 mt-3 text-center">
                                        <button
                                            type="submit"
                                            className="btn btn-blue btn-block"
                                            disabled={isLoading}
                                        >
                                            {isLoading ? (
                                                <PulseLoader color="#ffffff" size={8} />
                                            ) : (
                                                'Submit'
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                            <p className="mb-0 text-center mt-3">
                                Go to <Link to="/" className="text-center">Login</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Forget